import React from 'react';
import {Link} from 'react-router-dom';
import ImageWebp from 'react-image-webp';
import Constant from "../../utils/Constant";
import Cookies from "js-cookie";
import { decrypt, key } from "../../utils/encryptiondecryption";
class ChannelViewAll extends React.Component{
  constructor() {
    super();
    const ciphertext = Cookies.get('YUTETOLPBG-ASY1BSBD#!ASDNMlPOS--_AWQQWyADIURYBDSF092B34BSDSEWEWFELPOWD');
    const decryptedText = decrypt(ciphertext, key);
    this.state = {
      auth: {
        device_id: decryptedText.length > 1 ? (decryptedText[0][1] === 'null' ? null : decryptedText[0][1]) : null,
        phone_details: decryptedText.length > 1 ? (decryptedText[1][1] === 'null' ? null : decryptedText[1][1]) : null,
        user_id: decryptedText.length > 1 ? (decryptedText[2][1] === 'null' ? null : decryptedText[2][1]) : null,
        mobile: decryptedText.length > 1 ? (decryptedText[3][1] === 'null' ? null : decryptedText[3][1]) : null,
        package_id: decryptedText.length > 1 ? (decryptedText[4][1] === 'null' ? null : decryptedText[4][1]) : null,
        subscription_expiry_datetime: decryptedText.length > 1 ? (decryptedText[5][1] === 'null' ? null : decryptedText[5][1]) : null,
      },}}
    handleChannelList = () => {
        let channels = "";
        channels = this.props.data.map((channel,index) => (
            <div key={index} class="channel_live_cont_inner">
            <Link class="channel_sldr_box" to={!this.state.auth.user_id ? "/register" : (channel.channel_status === 'live' ? '/'+channel.channel_slug : "/"+channel.channel_slug)}>
            <div class="channel_sldr_img"><ImageWebp webp={channel.channel_logo_jpg} src={channel.channel_logo} alt={channel.channel_name}/>
              <div class="chnl_hvr_box"><span uk-icon="play"></span></div>
              <span class="live_span">{(channel.channel_status === 'live' ? channel.channel_status : '')}</span> </div>
            <div class="channel_sldr_txt">
              <h3 class="h3tag">{channel.channel_name}</h3>
            </div>
            </Link>
          </div>
                
        ));        
        return channels;
    };  
    render(){
        return (
            <div>
                <section class="pad_left pad_right pad_tb prog_box_sec">
                              
                  <div class="channel_live_cont">
                    {this.handleChannelList()}
                  </div>
                </section>
            </div>
        );
    }
}

export default ChannelViewAll;